import { logger } from '@origin-digital/reporting-client';
import { getRegisterBootstrapUrl } from 'ts/config/ConfigService';
import { EMAIL_OR_PHONE, USER_PROVIDED_USERNAME } from 'ts/constants/UrlParams';
import { ROUTES } from '../../../../Routes';
import { getDeviceId } from '../../../../url/UrlUtils';
import { sendOneTimeCodeRequest } from '../../../services/registration/RegistrationService';
import { ERROR_CODES } from '../../pages/error/ErrorCodes';
import { ErrorFlow } from '../../pages/error/ErrorFlow';
import { navigateToErrorPage } from '../../pages/error/ErrorNavigation';
import { History } from 'history';
import { OTCLocationState } from '../../pages/one-time-code/OneTimeCodePage';

const sendOtcAndRedirect = async (
  history: History<OTCLocationState>,
  username: string,
  userProvidedUsername: string,
  skipUsernameCheck = false,
) => {
  try {
    const otcResponse = await sendOneTimeCodeRequest(username, skipUsernameCheck);
    if (otcResponse.success) {
      return history.push({
        pathname: ROUTES.MANUAL_REG_ONE_TIME_CODE,
        search: `?${EMAIL_OR_PHONE}=${username}&${USER_PROVIDED_USERNAME}=${userProvidedUsername}`,
        state: {
          hideTryAgainLink: true,
        },
      });
    }
    // otherwise no user with that username found
  } catch (e) {
    // something went wrong with otc request
  }
  logger.fail('could not send otc for manual reg', { uniqueId: getDeviceId() });
  navigateToErrorPage(
    ERROR_CODES.MANUAL_REG_OTC_ERROR,
    ErrorFlow.manualReg,
    getRegisterBootstrapUrl(),
    history,
  );
};

export { sendOtcAndRedirect };
